// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hVB0","colMin":"styles_colMin__BHhmD"};